import * as React from "react";
import { VersionRowActions } from "./VersionRowActions";
import { IconChevronDown } from "./VersionIcons";
import {
  formatVersionDateCompact,
  type MajorVersionGroup,
} from "./versionHistoryUtils";

export type VersionMajorRowProps = {
  group: MajorVersionGroup;
  expanded: boolean;
  isCurrent: boolean;
  onToggle: () => void;
  promoting?: boolean;
  onPromote?: () => void;
  children?: React.ReactNode;
};

export const VersionMajorRow: React.FC<VersionMajorRowProps> = ({
  group,
  expanded,
  isCurrent,
  onToggle,
  promoting,
  onPromote,
  children,
}) => {
  const { major, revisions } = group;
  const label = major.display_label || `v${major.version}`;
  const hasRevisions = revisions.length > 0;

  return (
    <div className="versions-major">
      <div className="versions-row versions-row--major">
        {hasRevisions ? (
          <button
            type="button"
            className={`versions-chevron${expanded ? " is-expanded" : ""}`}
            onClick={onToggle}
            aria-expanded={expanded}
            aria-label={expanded ? `Collapse ${label}` : `Expand ${label}`}
          >
            <IconChevronDown />
          </button>
        ) : (
          <span className="versions-chevron-spacer" aria-hidden />
        )}
        <span className="versions-row__label">{label}</span>
        {isCurrent ? <span className="versions-current-badge">Current</span> : null}
        {major.major_origin_label ? (
          <span className="versions-row__origin">{major.major_origin_label}</span>
        ) : null}
        <span className="versions-row__date">{formatVersionDateCompact(major.created_at)}</span>
        <VersionRowActions
          label={label}
          version={major}
          promoting={promoting}
          onPromote={onPromote}
        />
      </div>
      {expanded && hasRevisions ? (
        <div className="versions-revisions">{children}</div>
      ) : null}
    </div>
  );
};
